import React from 'react';

import './Modal.less';

interface SbeModalProps {
  titleId: string;
  title: string;
  body: string;
  ctaHref: string;
  ctaLabel: string;
  onClose: () => void;
}

const SbeModal: React.FC<SbeModalProps> = ({
  titleId,
  title,
  body,
  ctaHref,
  ctaLabel,
  onClose,
}) => (
  <div
    className="sbe-modal-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby={titleId}
  >
    <div className="sbe-modal">
      <button type="button" className="sbe-modal-close" onClick={onClose}>
        ×
      </button>
      <p id={titleId} className="sbe-modal-title">
        {title}
      </p>
      <p className="sbe-modal-body">{body}</p>
      <a href={ctaHref} className="sbe-modal-btn sbe-modal-btn--primary">
        {ctaLabel}
      </a>
    </div>
  </div>
);

export default SbeModal;
